import {initState} from './store';

export default {
    setDefaultState(state) {
        Object.assign(state, initState());
    },

    setUser(state, user) {
        state.user = user;
    },

    setAuthentication(state, auth) {
        state.authenticated = auth;
    },
    setClients(state, clients) {
        state.clients = clients;
    },
    setCurrentClient(state, client) {
        state.currentClient = client
    },
    setUserRole(state, role) {
        state.userRole = role;
    }
}